import { InfoBanner, ConditionalRender } from '@ui';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { formatOpoNameWithCode } from '@features/components/CaseFormBlocks';
import { Case } from '@/api/apis/case';
import { OpoContactRow } from '../components/OpoContactRow';

type OpoSectionProps = Pick<Case, 'assignedOpoContacts' | 'opoDetails'>;

export const OpoSection = ({ assignedOpoContacts, opoDetails }: OpoSectionProps) => {
  const opoContact = assignedOpoContacts.find((contact) => contact.isPrimary);
  const secondaryOpoContact = assignedOpoContacts.find((contact) => !contact.isPrimary);
  const showNoOpoContactsBanner = !!opoDetails && !assignedOpoContacts.length;

  return (
    <>
      <SectionRow label="OPO">
        <ConditionalRender show={!!opoDetails} placeholder="-">
          <div className="truncate">{formatOpoNameWithCode(opoDetails as { name: string; code?: string | null })}</div>
        </ConditionalRender>
      </SectionRow>

      {showNoOpoContactsBanner && <InfoBanner iconType="warning">Selected OPO doesn’t have any contacts</InfoBanner>}

      <OpoContactRow label="OPO Contact" contact={opoContact} opoDetails={opoDetails} />
      <OpoContactRow label="OPO Contact (Optional)" contact={secondaryOpoContact} opoDetails={opoDetails} />
    </>
  );
};
